var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCorthouse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6666 21.168H7.33325C7.05992 21.168 6.83325 20.9413 6.83325 20.668C6.83325 20.3946 7.05992 20.168 7.33325 20.168H20.6666C20.9399 20.168 21.1666 20.3946 21.1666 20.668C21.1666 20.9413 20.9399 21.168 20.6666 21.168Z",
    fill: "#61676B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6667 10.1517C15.04 10.1517 14.4133 10.0317 13.8133 9.79167C13.6267 9.71834 13.5 9.53167 13.5 9.325V7.325C13.5 7.15833 13.58 7.005 13.72 6.91167C13.86 6.81834 14.0333 6.79833 14.1867 6.85833C15.14 7.23833 16.1933 7.23833 17.1467 6.85833C17.3 6.79833 17.4733 6.81834 17.6133 6.91167C17.7533 7.005 17.8333 7.15833 17.8333 7.325V9.325C17.8333 9.53167 17.7067 9.71167 17.52 9.79167C16.92 10.0317 16.2933 10.1517 15.6667 10.1517ZM14.5 8.97832C15.26 9.21165 16.0733 9.21165 16.8333 8.97832V8.01169C16.0667 8.19835 15.2667 8.19835 14.5 8.01169V8.97832Z",
    fill: "#61676B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 11.832C13.7267 11.832 13.5 11.6054 13.5 11.332V9.33203C13.5 9.0587 13.7267 8.83203 14 8.83203C14.2733 8.83203 14.5 9.0587 14.5 9.33203V11.332C14.5 11.6054 14.2733 11.832 14 11.832Z",
    fill: "#61676B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3334 21.1654H8.66675C8.39341 21.1654 8.16675 20.9387 8.16675 20.6654V13.332C8.16675 11.7187 9.05341 10.832 10.6667 10.832H17.3334C18.9467 10.832 19.8334 11.7187 19.8334 13.332V20.6654C19.8334 20.9387 19.6067 21.1654 19.3334 21.1654ZM9.16675 20.1654H18.8334V13.332C18.8334 12.2787 18.3867 11.832 17.3334 11.832H10.6667C9.61341 11.832 9.16675 12.2787 9.16675 13.332V20.1654Z",
    fill: "#61676B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9468 14.5H9.05347C8.78013 14.5 8.55347 14.2733 8.55347 14C8.55347 13.7267 8.78013 13.5 9.05347 13.5H18.9468C19.2201 13.5 19.4468 13.7267 19.4468 14C19.4468 14.2733 19.2201 14.5 18.9468 14.5Z",
    fill: "#61676B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8269 14H10.8269V20.6667H11.8269V14Z",
    fill: "#61676B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4934 14H13.4934V20.6667H14.4934V14Z",
    fill: "#61676B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1602 14H16.1602V20.6667H17.1602V14Z",
    fill: "#61676B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorthouse);
export default __webpack_public_path__ + "static/media/corthouse.cd65918719384bf9a0d4e658c90af184.svg";
export { ForwardRef as ReactComponent };